import React, {
  useCallback,
  useState,
} from 'react'
import {
  useLocation,
  useHistory,
} from 'react-router-dom'
import { useSSE } from 'use-sse'

import useClientSideState from 'hooks/useClientSideState'

import {
  get,
  ApiResponse,
} from 'utils/apis/insuranceLounge'

import { getUriWithQueryStringValue } from 'utils/string'

import Http500 from 'screens/500'

import {
  Post,
  Tag,
} from '../types'

import { ApiData } from './types'

import BlogLanding from './index.presentational'

const BlogLandingContainer: React.FC = (): React.ReactElement => {
  const history = useHistory()
  const location = useLocation()

  const tagSlugRegex = /^.*[&?]{1}tag=([^&]*).*$/
  const queryStringTagSlug = (location.search.match(tagSlugRegex) && location.search.replace(tagSlugRegex, '$1')) || undefined
  const [
    selectedTagSlugFilter,
    setSelectedTagSlugFilter,
  ] = useState<string | undefined>(queryStringTagSlug)

  const [
    isTagsLoading,
    setIsTagsLoading,
  ] = useClientSideState<boolean>(false)

  const [
    isFeaturedPostLoading,
    setIsFeaturedPostLoading,
  ] = useClientSideState<boolean>(false)

  const [
    data,
    error,
  ] = useSSE((): Promise<ApiData> => {
    setIsTagsLoading(true)
    setIsFeaturedPostLoading(true)

    return Promise.all([
      get('/blog/posts?limit=1'),
      get('/blog/tags?havePosts'),
    ])
      .then((responses: ApiResponse[]): ApiData => {
        const featuredPost = responses[0]?.status === 200 ? responses[0].data[0] as Post : undefined

        const tags = responses[1]?.status === 200 ? responses[1].data as Tag[] : undefined

        return {
          featuredPost,
          tags,
        } as ApiData
      })
      .finally(() => {
        setIsFeaturedPostLoading(false)
        setIsTagsLoading(false)
      })
  }, [])

  const onChangeTagFilter = useCallback(slug => {
    const newUri = getUriWithQueryStringValue(location, 'tag', slug || undefined)
    history.push(newUri)

    setSelectedTagSlugFilter(slug)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  if (error) {
    return React.createElement(Http500)
  }

  const {
    featuredPost,
    tags,
  } = (data || {})

  return React.createElement(
    BlogLanding,
    {
      featuredPost,
      isFeaturedPostLoading,
      isTagsLoading,
      onChangeTagFilter,
      selectedTagSlugFilter,
      tags,
    },
  )
}

export default BlogLandingContainer
